export const HERO_CONSTANTS = {
  TAG: "Sustainable Agriculture",
  DATE: "October 23, 2023",
  TITLE: "Harnessing the Power of Agrivoltaics for Sustainable Farming",
  DESCRIPTION:
    "Discover how agrivoltaics combines agriculture and solar energy to create sustainable farming solutions. Learn about the benefits and applications of this innovative approach.",
  HERO_IMAGE:
    "https://images.pexels.com/photos/3184470/pexels-photo-3184470.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
};

export const ARTICLE_SUMMARY = [
  "Agrivoltaics is an innovative approach that combines agriculture and solar energy to create sustainable farming solutions. This guide explores the benefits and applications of agrivoltaics in promoting sustainable agriculture and renewable energy production.",
  "From improving crop yields to generating clean energy, agrivoltaics offers a range of advantages for farmers and the environment. We'll delve into the technology behind agrivoltaics and how it can support sustainable farming practices.",
  "Whether you're a farmer looking to enhance your operations or an environmental advocate seeking sustainable solutions, agrivoltaics provides a promising option. Let's explore the potential benefits and applications of agrivoltaics.",
];

export const ARTICLE_STEPS = [
  {
    title: "1. Understanding Agrivoltaics",
    content:
      "Agrivoltaics, also known as agrophotovoltaics, involves the simultaneous use of land for both agriculture and solar energy production. Solar panels are installed above crops, allowing sunlight to reach the plants while generating electricity. This dual-use approach maximizes land efficiency and provides multiple benefits for farmers and the environment.",
  },
  {
    title: "2. Benefits of Agrivoltaics",
    content:
      "Agrivoltaics offers several benefits, including increased land productivity, improved crop yields, and renewable energy generation. The shade provided by solar panels can reduce water evaporation and protect crops from extreme weather conditions. Additionally, the electricity generated can be used to power farm operations or sold to the grid, providing an additional income stream for farmers.",
  },
  {
    title: "3. Applications in Sustainable Farming",
    content:
      "Agrivoltaics can be applied to various types of farming, including crop cultivation, livestock grazing, and aquaculture. In crop cultivation, solar panels can be installed above fields to provide shade and generate electricity. In livestock grazing, solar panels can create shaded areas for animals while producing renewable energy. In aquaculture, solar panels can be used to power water pumps and aeration systems.",
  },
  {
    title: "4. Implementing Agrivoltaic Systems",
    content:
      "Implementing agrivoltaic systems requires careful planning and consideration of factors such as crop type, solar panel placement, and energy needs. Collaboration with agricultural and solar energy experts can help ensure successful implementation. It's also important to consider the financial and regulatory aspects of agrivoltaic projects, including funding options and permits.",
  },
  {
    title: "5. Challenges and Considerations",
    content:
      "While agrivoltaics offers many benefits, there are also challenges to consider. These include the initial cost of installation, potential impacts on crop growth, and maintenance requirements. Addressing these challenges requires careful planning, ongoing monitoring, and adaptive management practices.",
  },
  {
    title: "6. Future Trends and Developments",
    content:
      "The field of agrivoltaics is rapidly evolving, with new advancements and innovations being introduced regularly. Staying informed about the latest trends and developments can help farmers and stakeholders leverage the full potential of agrivoltaics and contribute to sustainable agriculture and renewable energy goals.",
  },
];

export const RELATED_ARTICLES = [
  {
    image:
      "https://images.pexels.com/photos/3184471/pexels-photo-3184471.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    date: "October 20, 2023",
    title: "Top Innovations in Sustainable Agriculture",
    description:
      "Explore the latest innovations in sustainable agriculture, from agrivoltaics to precision farming. Learn how these advancements are promoting environmental sustainability and improving farm productivity.",
  },
  {
    image:
      "https://images.pexels.com/photos/3184472/pexels-photo-3184472.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    date: "October 15, 2023",
    title: "How to Implement Renewable Energy Solutions on Your Farm",
    description:
      "Discover practical tips for implementing renewable energy solutions on your farm. Learn about different options, including solar, wind, and biomass, and how to choose the best solution for your needs.",
  },
  {
    image:
      "https://images.pexels.com/photos/3184473/pexels-photo-3184473.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    date: "October 12, 2023",
    title: "Understanding the Benefits of Solar Energy for Agriculture",
    description:
      "Dive into the benefits of solar energy for agriculture and how it can support sustainable farming practices. Learn about the potential applications and advantages of integrating solar energy into your farm operations.",
  },
];

export const FOOTER_CONSTANTS = {
  CTA_TITLE: "Embrace Sustainable Farming with Agrivoltaics",
  CTA_BACKGROUND:
    "https://images.pexels.com/photos/3184474/pexels-photo-3184474.jpeg",
  EMAIL_PLACEHOLDER: "Enter your email address",
  BUTTON_TEXT: "Learn More",
  COPYRIGHT: " 2024 Sustainable Agriculture. All rights reserved",
};
